"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.repeatScheduleTask = exports.scheduleAtFixedRate = void 0;
const abortableTimers_1 = require("./abortableTimers");
/*
 * @param {number} interval - execute task when UTC timestamp is divisible by the given interval
 *                            e.g. scheduleAtFixedRate(() => {},  24 * 60 * 60 * 1000) triggers the
 *                            task once a day at 00:00 UTC
 *                            (but no tasks will be executed concurrently: if a previous task is
 *                            still ongoing when the next task should, the new task is silently skipped)
 */
const scheduleAtFixedRate = (task, interval, abortSignal) => {
    (0, exports.repeatScheduleTask)((doneCb) => {
        const now = Date.now();
        const next = now - (now % interval) + interval;
        (0, abortableTimers_1.setAbortableTimeout)(async () => {
            await task(next);
            doneCb();
        }, (next - now), abortSignal);
    }, abortSignal);
};
exports.scheduleAtFixedRate = scheduleAtFixedRate;
/** @internal */
const repeatScheduleTask = (scheduleNextTask, abortSignal) => {
    const scheduleNext = () => {
        if (!abortSignal?.aborted) {
            scheduleNextTask(scheduleNext);
        }
    };
    scheduleNext();
};
exports.repeatScheduleTask = repeatScheduleTask;
//# sourceMappingURL=scheduleAtFixedRate.js.map